// extracted by mini-css-extract-plugin
export default {"cost":"styles_cost__5GuBm","switch":"styles_switch__X7tZe"};